import api from './api'

// const resource = '/auth'

export default {
    login(params) {
        return api.post(`/auth/login`, params);
    },
    get() {
        return api.get(`/admin/profile`);
    },
    profile(params) {
        return api.post(`/admin/profile`, params);
    },
    getUsers(page, q, per_page) {
        return api.get(`/admin/users?page=${page}&q=${q}&per_page=${per_page}`);
    },
    password(params) {
        return api.put(`/admin/profile/password`, params);
    },
    updateUser(id, params) {
        return api.put(`/admin/users/${id}`, params);
    },
    createUser(params) {
        return api.post(`/admin/users`, params);
    },
    deleteUser(id) {
        return api.delete(`/admin/users/${id}`);
    },
    getUser(npp) {
        return api.get(`/admin/users/${npp}`);
    }
}